<script>
import axios from 'axios';
import { cmsUrl } from '../variables';

export default {
    name: 'OrganisationItemDelete',
    data() {
        return {
            itemData: null,
            itemId: null,
            isLoading: true,
            isDeleting: false,
            deleteError: false,
        }
    },
    mounted() {
        this.itemId = this.$route.params.itemId;
        if (this.itemId)
            this.init(this.itemId)
    },
    methods: {
        init(id) {
            this.isLoading = true;
            axios
                .get(cmsUrl + '/organisations/post?id=' + id)
                .then(this.onDataLoaded)
                .catch(() => this.onError())
        },
        onDataLoaded(data) {
            if (!data || !data.data) {
                this.onError();
                return;
            }
            this.itemData = data.data;
            this.isLoading = false;
        },
        onError() {
            this.isLoading = false;
        },
        onDelete(e) {
            e.preventDefault();
            if (this.isDeleting) return;
            
            this.isDeleting = true;
            this.deleteError = false;
            axios
                .post(cmsUrl + '/organisations/post/delete', {
                    id: this.itemId,
                    organisation_id: this.$route.params.organisationId,
                })
                .then(() => {
                    this.isDeleting = false;
                    this.$router.push('/organisation/' + this.$route.params.organisationId);
                })
                .catch(() => {
                    this.isDeleting = false;
                    this.deleteError = true;
                })
            
        },
        onCancel(e) {
            e.preventDefault();
            this.$router.push('/organisation/' + this.$route.params.organisationId);
        },
    },
};
</script>

<template>
    <section class="item-delete">
        <div v-if="!isLoading">
            <h1 class="item-delete__title page-title">{{$t('organisationItemDelete.title')}}</h1>
            <p class="item-delete__lead page-lead">{{$t('organisationItemDelete.msg', { title: itemData.post_title })}}</p>
            <div class="item-delete__actions">
                <button class="button button--primary" v-on:click="onDelete($event)"><span v-if="!isDeleting">{{$t('organisationItemDelete.buttonDelete')}}</span><span v-if="isDeleting">{{$t('organisationItemDelete.loading')}}</span></button>
                <button class="button button--secondary" v-on:click="onCancel($event)">{{$t('organisationItemDelete.buttonCancel')}}</button>
            </div>
        </div>
    </section>
</template>

<style lang="scss" scoped>
.item-delete__lead {
    max-width: 48rem;
    margin-bottom: 8rem;
}
</style>
